{"errno":-2,"code":"ENOENT","syscall":"open","path":"/tmp/tmp-85364SMID42Np6SRF/packages/auth/dist/[synthetic:util/polyfill]"}